import { createSelector } from 'reselect';

const groupsState = (store) => store.apps.teamManagement.groups;
const organizationState = (store) => store.apps.teamManagement.organization;
const userState = (store) => store.user;

const containerSelector = createSelector(
  groupsState,
  organizationState,
  (filteredState, organization) => ({
    groups: filteredState.get('results'),
    groupsCount: filteredState.get('count'),
    loading: filteredState.get('loading'),
    selectedGroups: filteredState.get('selectedGroups'),
    organization: organization.get('organization'),
  }),
);

const groupsSelector = createSelector(
  groupsState,
  (filteredState) => ({ groups: filteredState.get('results') }),
);

const organizationSelector = createSelector(
  userState,
  (filteredState) => ({ organization: filteredState.organization }),
);

export default containerSelector;
export {
  containerSelector,
  groupsSelector,
  groupsState,
  organizationSelector,
};
